import type { ContentObjectList } from 'models';
import { useCallback } from 'react';

const getPinnedPostText = (item: ContentObjectList) => {
  switch (item.type) {
    case 'activity':
    case 'comment':
    case 'event':
    case 'giving':
    case 'video':
    case 'withings_order_post':
      return undefined;
    case 'kudo':
      return item.kudo.textContent;
    case 'poll':
      return item.poll.questions[0]?.question ?? '';
    case 'post':
      return item.post.textContent ?? '';
  }
};

const getPinnedPostImageUrl = (item: ContentObjectList) => {
  // TODO: #87927 This image lookup is copied in PinnedContentObjectCard. Replace both with one function. useImageAttachments only filters image attachments, it does not return the first url.
  const attachmentImageUrl = item.attachments.find((attachment) => attachment.contentType.startsWith('image'))?.url;

  if (attachmentImageUrl) {
    return attachmentImageUrl;
  }

  if (item.contentableType !== 'Community') {
    return undefined;
  }

  return item.postInCommunities[0].coverPhoto.url;
};

export const useGetPinnedPostPreview = () =>
  useCallback((item: ContentObjectList) => {
    const text = getPinnedPostText(item)?.trim() ?? '';

    return {
      imageUrl: getPinnedPostImageUrl(item),
      text,
    };
  }, []);
